import { render, staticRenderFns } from "./CheckboxGrid.vue?vue&type=template&id=6f752213&scoped=true"
import script from "./CheckboxGrid.vue?vue&type=script&lang=js"
export * from "./CheckboxGrid.vue?vue&type=script&lang=js"
import style0 from "./CheckboxGrid.vue?vue&type=style&index=0&id=6f752213&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f752213",
  null
  
)

export default component.exports